/** @format */

import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';

import { HmfActionTextComponent } from '@dsg-tech/homefield-angular';
import { NgClass } from '@angular/common';
import { Store } from '@ngrx/store';
import { WINDOW } from '@shared/data-access/services';
import { selectKillswitch } from '@pdp/data-access/state';
import { selectUserZipCode } from '@state/data-access';

@Component({
	selector: 'pdp-feature-change-zip-code-button',
	styleUrl: './change-zip-code-button.component.scss',
	templateUrl: './change-zip-code-button.component.html',
	imports: [HmfActionTextComponent, NgClass],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangeZipCodeButtonComponent {
	protected readonly window = inject(WINDOW) as Window;
	private readonly store = inject(Store);

	readonly isSubtext = input(false);
	readonly isDisabled = input(false);
	readonly isSubtle = input(false);

	readonly zipcode = this.store.selectSignal(selectUserZipCode);
	readonly sameDayDeliveryEnabled = this.store.selectSignal(
		selectKillswitch('sameDayDeliveryEnabled')
	);

	openZipCodePanel() {
		this.window.headerFunctions.sameDayDelivery();
	}
}
